import React, { Component } from 'react'
export class Tabs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tabActive: 'listRole',
        }
        this.tabData = [
            {
                title: 'Danh sách vai trò',
                id: 'listRole',
            },
            {
                title: 'Chi tiết phạm vi',
                id: 'rangeDetail',
            },
        ]
    }

    onChangeTab = tab => {
        this.setState({ tabActive: tab }, ()=>{
            this.props.onChangeTab(tab)
        })
    }

    render() {
        const { tabActive } = this.state;
        return (
                <div className="nav-tabs ">
                    {this.tabData.map(value => {
                        return <div
                            key={value.id}
                            onClick={() => this.onChangeTab(value.id)}
                            className={`nav-link ${tabActive === value.id ? 'active' : ''}`}>
                            {value.title}
                        </div>
                    })}

                </div>
        )
    }
}
